import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import $ from 'jquery';

$(() => {
  Fancybox.bind('[data-fancybox="gallery"]', {
    animated: true,
    infinite: true,
  });

  function initGallerySliders() {
    const mainGallerySlide = new Splide('#product-image-gallery-slider', {
      type: 'slide',
      rewind: true,
      arrows: false,
      pagination: false,
    });

    const galleryThumbnailControls = new Splide(
      '#single-product-gallery-thumbnail-splide',
      {
        type: 'slide',
        rewind: true,
        perPage: 4,
        perMove: 1,
        pagination: false,
        isNavigation: true,
      }
    );

    mainGallerySlide.sync(galleryThumbnailControls);
    mainGallerySlide.mount();
    galleryThumbnailControls.mount();

    $(window).on('resize', function () {
      mainGallerySlide.refresh();
      galleryThumbnailControls.refresh();
    });

    $('.desktop-thumbnail').on('click', function () {
      const splideIndex = $(this).index();
      mainGallerySlide.go(splideIndex);
      updateThumbnailState(mainGallerySlide);
    });

    mainGallerySlide.on('move', function () {
      updateThumbnailState(mainGallerySlide);
    });

    galleryThumbnailControls.on('move', function () {
      updateThumbnailState(mainGallerySlide);
    });
  }

  function updateThumbnailState(mainGallery) {
    const currentIndex = mainGallery.index;
    $('.desktop-thumbnail img').removeClass('border');
    $('.desktop-thumbnail div').removeClass('font-semibold');
    const currentDesktopThumbnail = $('.desktop-thumbnail').eq(currentIndex);
    currentDesktopThumbnail.find('img').addClass('border');
    currentDesktopThumbnail.find('div').addClass('font-semibold');
    $('.mobile-thumbnail img').removeClass('border');
    $('.mobile-thumbnail div').removeClass('font-semibold');
    const currentMobileThumbnail = $('.mobile-thumbnail').eq(currentIndex);
    currentMobileThumbnail.find('img').addClass('border');
    currentMobileThumbnail.find('div').addClass('font-semibold');
  }

  if ($('#product-image-gallery-slider').length > 0) {
    initGallerySliders();
  }
});
